export enum ConsentType {
  'PLATFORM_TERMS_OF_USE' = 'PLATFORM_TERMS_OF_USE',
  'PLATFORM_PRIVACY_NOTICE' = 'PLATFORM_PRIVACY_NOTICE',
  'SERVICE_CONDITIONS' = 'SERVICE_CONDITIONS',
  'SERVICE_GTC' = 'SERVICE_GTC',
}

export enum ConsentStatus {
  'PENDING' = 'PENDING',
  'ACCEPTED' = 'ACCEPTED',
  'OUTDATED' = 'OUTDATED',
}

export type UserConsentResponseDto = {
  consentType: ConsentType;
  status: ConsentStatus;
  userId: string;
  organizationId: string;
  legalDocumentVersion: number;
  createdAt: Date;
  givenAt: Date;
  objectionPeriodStart: Date;
  objectionPeriodEnd: Date;
  version: number;
};

export type UserTermsOfUse = Pick<UserConsentResponseDto, 'consentType' | 'givenAt' | 'legalDocumentVersion'>;

export type ConsentAndChangeNoticesResponseDto = {
  userId: string;
  organizationId: string;
  consents: ConsentDto[];
  insignificantChangeNotices: InsignificantChangeNoticeResponseDto[];
};

export type ConsentDto = {
  consentType: ConsentType;
  status: ConsentStatus;
  legalDocumentVersion: number;
};

export type InsignificantChangeNoticeResponseDto = {
  id: string;
  consentType: ConsentType;
  legalDocumentVersion: number;
  changeDescription: string;
  cartridgeId?: string;
  cartridgeName?: string;
};

export type VersionedLegalDocumentDto = {
  consentType: ConsentType;
  legalDocumentVersion: number;
  createdAt: string;
};

export type LegalDocumentsMetaData = {
  id: string;
  cartridgeId: string;
  cartridgeName: string;
  customerGroup: CustomerGroups;
  validityDate: string;
  version: number;
};

export enum CustomerGroups {
  DEALER = 'DEALER',
  SUPPLIER = 'SUPPLIER',
  EZR_DEALER = 'EZR_DEALER',
  EZR_SUPPLIER = 'EZR_SUPPLIER',
}

export interface LegalDocumentRequestDto {
  serviceId: string;
  file: File;
  typeOfLegalDocumentChange: string;
  targetGroup: CustomerGroups | '';
  validFrom: string | null;
  changeDescriptionDeDe: string;
  changeDescriptionEnGb: string;
}

export interface Consent {
  consentType: ConsentType;
  changeDescriptions: Record<string, string>[];
  hasChanged: boolean;
  areChangesSignificant: boolean;
}
